// Types
import {
  GetStream_stream_mentions,
  GetStream_stream_hashtags,
} from 'api/streams/types/GetStream';
import { StreamStatus } from 'api/graphql-global-types';
// Helpers
import { parseForInnerHTML } from 'helpers/textEditor';
// Components
import MentionsView from 'components/MentionsView/MentionsView';
import Modal from 'ui3/Modal/Modal';
// UI
import HashTags from 'ui3/HashTags/HashTags';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './StreamDetailsModal.module.scss';

type StreamDetailsModalProps = {
  open: boolean;
  onClose: () => void;
  description: string | null;
  dateTimeText: string;
  mentions: GetStream_stream_mentions[];
  hashtags: GetStream_stream_hashtags[];
  views: number | null;
  streamStatus: StreamStatus;
  showDisclaimer: boolean;
};

const StreamDetailsModal = ({
  open,
  onClose,
  description,
  dateTimeText,
  mentions,
  hashtags,
  views,
  streamStatus,
  showDisclaimer,
}: StreamDetailsModalProps) => {
  const isStreamEnded = streamStatus === StreamStatus.Ended;
  const showViews = isStreamEnded && views != null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      blockScroll={true}
      showCloseIcon={false}
      modalStyles={{
        padding: '0', // removes padding from the modal component, was necessary here
      }}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2 className={styles.modalTitle}>Details</h2>
          {/* smaller, inline close button-instead of the classic one from Modal component */}
          <button
            type="button"
            onClick={onClose}
            className={styles.closeButton}
            aria-label="Close"
          >
            <MillionsIcon name="close" size={22} className={styles.closeIcon} />
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.dateTimeRow}>
            {showViews && (
              <span className={styles.viewsText}>
                <MillionsIcon name="eye" size={16} className={styles.eyeIcon} />
                {views} views
              </span>
            )}
            <span className={styles.dateText}>{dateTimeText}</span>
          </div>

          {description && (
            <div
              className={styles.descriptionText}
              dangerouslySetInnerHTML={{
                __html: parseForInnerHTML(description),
              }}
            />
          )}

          {mentions && mentions.length > 0 && (
            <div className={styles.mentionsSection}>
              <MentionsView mentions={mentions as any} size="sm" />
            </div>
          )}

          {hashtags && hashtags.length > 0 && (
            <>
              <hr className={styles.dividerLine} />
              <p className={styles.hashtagsLabel}>TAGS</p>
              <div className={styles.hashtagsSection}>
                <HashTags
                  tags={hashtags}
                  className={styles.inlineTags}
                  hashTagClassName={styles.smallHashTag}
                />
              </div>
            </>
          )}

          {showDisclaimer && (
            <>
              <hr className={styles.dividerLine} />
              <p className={styles.disclaimer}>
                {/* copied from VideoDetails component, if you change it here, you probably need to change it there too */}
                Disclaimer: MILLIONS.co served as the streaming platform and
                completed all required testing. The event&apos;s live feed and
                technical production were managed independently by a third-party
                provider.
              </p>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default StreamDetailsModal;
